import { render } from "./OrderStatus.vue?vue&type=template&id=f5af9db8"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=f5af9db8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__